import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProductsBanner from "../components/ProductsBanner";
import ContactForm from "../components/ContactForm";
import ContactMap from "../components/ContactMap";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import { Helmet } from "react-helmet";
const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>
          Contact Us - DrChek | Smart Healthcare & Diagnosis Solutions
        </title>
        <meta
          name="description"
          content="Get in touch with DrChek for any inquiries, support, or more information about our healthcare and diagnostic solutions."
        />
        <meta
          name="keywords"
          content="Contact DrChek, Healthcare Support, Medical Inquiries, Contact Healthcare Solutions, DrChek Customer Service"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <Header />
      <ProductsBanner
        title="Contact Us"
        backgroundImage="/images/dr-chek-banner-001.png"
        backgrond="cover"
        height="400px"
      />
      <ContactForm />

      <ContactMap />
      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
};

export default Contact;
